import { Button, cn, RadioGroup, RadioGroupItem } from "web-design-system";
import { RiskProfileQuestion } from "./types";

export interface QuestionStepProps {
  question: RiskProfileQuestion;
  value?: string;
  onChange: (optionId: string) => void;
  onNext: () => void;
  onPrevious: () => void;
  canGoPrevious: boolean;
  isLastQuestion: boolean;
  submitting: boolean;
}

export function QuestionStep({
  question,
  value,
  onChange,
  onNext,
  onPrevious,
  canGoPrevious,
  isLastQuestion,
  submitting,
}: QuestionStepProps) {
  return (
    <div className="flex flex-col h-full min-h-0">
      <div className="flex-1 flex flex-col gap-8 py-8 min-h-0 overflow-y-auto">
        <p className="text-lg font-semibold leading-6! text-foreground">
          {question.text}
        </p>

        <RadioGroup
          key={question.id}
          value={value}
          onValueChange={onChange}
          className="gap-3"
        >
          {question.options.map((option) => (
            <label
              key={option.id}
              className={cn(
                "flex cursor-pointer items-center gap-3 rounded-lg border p-4 text-sm transition-colors",
                value === option.id
                  ? "border-foreground"
                  : "border-border hover:border-foreground/40"
              )}
            >
              <RadioGroupItem value={option.id} />
              {option.label}
            </label>
          ))}
        </RadioGroup>
      </div>

      <div className="flex justify-end gap-2 pt-9">
        <Button
          variant="outline"
          onClick={onPrevious}
          disabled={!canGoPrevious || submitting}
        >
          Previous
        </Button>
        <Button onClick={onNext} disabled={!value || submitting}>
          {isLastQuestion ? (submitting ? "Submitting..." : "Submit") : "Next"}
        </Button>
      </div>
    </div>
  );
}
